<template>
  <b-overlay :show="loading" class="px-2">
    <b-row class="mt-2">
      <b-col cols="12" md="12">
        <div class="mb-2 text-center">
          <b-media class="text-center">
            <b-avatar
              ref="previewEl"
              badge-variant="transparent"
              :src="avatarPath"
              :text="avatarText(`${memberProfile.first_name} ${memberProfile.last_name}`)"
              :variant="`light-primary`" size="9rem"
            >
              <template #badge>
                <b-button variant="primary" class="btn-icon rounded-circle"
                  @click="$refs.avatar.$el.childNodes[0].click()"
                >
                  <feather-icon icon="CameraIcon" />
                </b-button>
              </template>
            </b-avatar>
          </b-media>

          <div>
            <b-form-file v-show="false" ref="avatar" accept="image/*" placeholder="" no-drop @input="onImageRenderer" />
          </div>
        </div>
      </b-col>

      <b-col>
        <h1 v-if="memberName" class="mb-0 text-center" style="font-size: 25px;">
          {{ memberName }}
          <b-button size="sm" variant="outline-primary" @click="$router.push(viewRoute)">
            <span class="d-flex justify-content-center align-items-center" style="gap: 2px">
              <feather-icon icon="EyeIcon" size="16" />
              View
            </span>
          </b-button>
        </h1>
      </b-col>
    </b-row>

    <div v-if="memberProfile._id" class="my-1">
      <b-alert v-if="errorMessage" variant="danger" :show="true">
        <div class="alert-body font-small-2">
          <b-card-text class="mb-0">
            {{ errorMessage }}
          </b-card-text>
        </div>
      </b-alert>

      <div>
        <b-card no-body>
          <b-tabs v-model="tabIndex" align="center" class="minister-profile" card pills justified fill>
            <b-tab title="Personal Profile" active>
              <MemberUpdatePersonalData
                :initial-values="personalMemberProfile"
                :country-options="countryOptions"
                :gender-options="genderOptions"
              />
            </b-tab>

            <b-tab v-if="isCopMinister" title="Ministry">
             <MinistryUpdate
                :initial-values="ministryProfile"
                :country-options="countryOptions"
                :member-status-options="memberStatusOptions"
                :member-type-options="member_types"
                :country="memberProfile.country"
                :department-options="departmentOptions"
                :is-cop-minister="isCopMinister"
              />
            </b-tab>
            <b-tab v-else title="Member Profile">
              <MemberProfileUpdate
                :initial-values="churchMemberProfile"
                :country-options="countryOptions"
                :member-status-options="memberStatusOptions"
                :member-type-options="member_types"
                :country="memberProfile.country"
              />
            </b-tab>

            <b-tab title="Education">
              <EducationHistoryList v-if="memberProfile.user_id" :user-id="memberProfile.user_id" :is-minister="ministersOnly" />
            </b-tab>

            <b-tab title="Work Experience">
              <WorkExperienceList v-if="memberProfile.user_id" :user-id="memberProfile.user_id" />
            </b-tab>

            <b-tab v-if="ministersOnly" title="Stations">
              <MinisterStationsList :profile-id="memberProfile._id" :current-stations="memberProfile.stations"
                :user-id="memberProfile.user_id"
/>
            </b-tab>

            <b-tab v-if="spouse" title="Spouse">
              <b-card class="rounded-lg card" style="max-width: fit-content;">
                <div class="card-body">
                  <b-row>
                    <b-col cols="12" md="12" class="px-3">
                      <div class="text-center">
                        <b-avatar ref="previewEl" size="10rem" variant="light-success"
                          :src="getValueFromSource(spouse, 'member_profile.avatar.path')" text="Prince"
/>

                        <h2 class="mt-2 text-dark">
                          {{ getValueFromSource(spouse, 'full_name') }}
                        </h2>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mt-3">
                        <div class="w-50">
                          <h5 class="lead text-muted">
                            First Name
                          </h5>

                          <h5 class="text-dark">
                            {{ getValueFromSource(spouse, 'member_profile.first_name') }}
                          </h5>
                        </div>

                        <div class="w-50">
                          <h5 class="lead text-muted text-right">
                            Last Name
                          </h5>

                          <h5 class="text-dark text-right">
                            {{ getValueFromSource(spouse, 'member_profile.last_name') }}
                          </h5>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mt-3">
                        <div class="w-50">
                          <h5 class="lead text-muted">
                            Email
                          </h5>

                          <h5 class="text-dark">
                            {{ getValueFromSource(spouse, 'email') }}
                          </h5>
                        </div>

                        <div class="w-50">
                          <h5 class="lead text-muted text-right">
                            Phone
                          </h5>

                          <h5 class="text-dark text-right">
                            {{ getValueFromSource(spouse, 'phone') }}
                            
                          </h5>
                        </div>
                      </div>
                      <b-button variant="outline-primary" type="button" class="mt-2"
                      :to="{ name: 'members-detail', params: { id: getValueFromSource(spouse, 'member_profile._id') } }"
>
                      View Profile
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-card>
      </div>

    </div>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAvatar,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
  BFormCheckbox,
  BAlert,
  BCardText,
  BModal,
  BMedia,
  BMediaBody,
  BMediaAside,
  BImg,
  BTabs,
  BTab,
  BCard,
  BFormDatepicker
} from "bootstrap-vue";

import { required } from "@validations";
import { get, cloneDeep, pick } from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
import Ripple from "vue-ripple-directive";
import MinistryUpdate from "@/@core/components/member-update-forms/ministry-update.vue"
import EducationHistoryList from "@/@core/components/education/EducationHistoryList.vue";
import WorkExperienceList from "@/@core/components/work-experience/WorkExperienceList.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MinisterStationsList from "@/@core/components/minister-stations/MinisterStationsList.vue";
import MemberProfileUpdate from "@/@core/components/member-update-forms/member-profile-update.vue"
import MemberUpdatePersonalData from "@/@core/components/member-update-forms/update-personal-data.vue"

const rawData = {
  gender: "",
  first_name: "",
  last_name: "",
  date_of_birth: "",
  year_called_into_ministry: "",

  minister_id: "",
  department_id: "",
  member_type_id: "",
  member_title_id: "",
  member_designation_id: "",

  country: "Ghana",
  region: "",
  area: "",
  district: "",
  assembly: "",

  region_id: "",
  area_id: "",
  district_id: "",
  assembly_id: "",


  home_town: "",
  profession: "",
  called_from: "",
  qualifications: "",
  languages_spoken: "",
  years_in_current_area: 0,
  is_tent_minister: false,
  member_status_id: null,

  stations: [
    {
      title: "",
      year: "",
    },
  ],
  years_in_current_station: 0,

  member_type: {},
};

const rawBioData = {
  stations: [
    {
      title: "",
      year: "",
    },
  ],
};

const memberTitlesAndDesignationCachedData = [];

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BTab,
    BCard,
    BTabs,
    BForm,
    BAlert,
    BModal,
    BMedia,
    BButton,
    Cleave,
    vSelect,
    BAvatar,
    BOverlay,
    BSidebar,
    BCardText,
    BFormFile,
    BFormGroup,
    BMediaBody,
    BFormInput,
    BMediaAside,
    BFormCheckbox,
    BFormTextarea,
    MinistryUpdate,
    BFormDatepicker,
    WorkExperienceList,
    MemberProfileUpdate,
    EducationHistoryList,
    BFormInvalidFeedback,
    MinisterStationsList,
    MemberUpdatePersonalData,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    ministersOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      memberProfile: cloneDeep(rawData),
      bio_data: cloneDeep(rawBioData),
      loading: false,
      errorMessage: "",

      tabIndex: 0,
      member_types: [],
      memberTitleOptions: [],
      memberDesignationOptions: [],

      genderOptions: [
        {
          value: "female",
          label: "Female",
        },
        {
          value: "male",
          label: "Male",
        },
      ],

      temp_area: "",
      temp_region: "",
      temp_district: "",
      temp_member_types: "",
      temp_member_type_id: "",

      avatarPath: "",
      avatarImage: "",
      departmentOptions: [],
      regionOptions: [],
      areaOptions: [],
      districtOptions: [],
      assemblyOptions: [],
      countryOptions: [],
      memberStatusOptions: [],

      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
        blocks: [4, 2, 2],
      },

      required,
    };
  },
  computed: {
    ministryProfile() {
      const personal_fields = [
        "minister_id",
        "department_id",
        "member_type_id",
        "member_title_id",
        "member_designation_id",

        "region_id",
        "area_id",
        "district_id",
        "assembly_id",

        "is_tent_minister",

        "called_from",
        "member_status_id",
        "years_in_current_area",
        "years_in_current_station",
        "year_called_into_ministry",
      ]
      return pick(this.memberProfile, personal_fields);
    },
    personalMemberProfile() {
      const personal_fields = [
        "first_name",
        "last_name",
        "gender",
        "date_of_birth",
        "country",
        "home_town",
        "profession",
        "languages_spoken",
        "qualifications"
      ]
      return pick(this.memberProfile, personal_fields);
    },
    churchMemberProfile() {
      const personal_fields = [
        "member_type_id",
        "member_status_id",
        "region_id",
        "area_id",
        "district_id",
        "assembly_id",
      ]
      return pick(this.memberProfile, personal_fields);
    },
    isUpdate() {
      return !!this.memberProfile;
    },
    disableForm() {
      if (this.isUpdate) {
        return !this.can("member_profiles:CanUpdate");
      }

      return !this.can("member_profiles:CanAddNew");
    },
    isCopMinister() {
      const selected_member_type = this.member_types.find(
        (member_type) => member_type.value === this.memberProfile.member_type_id
      );

      return selected_member_type
        ? selected_member_type.is_cop_minister
        : false;
    },
    spouse() {
      const wife = this.getValueFromSource(this.memberProfile, "wife_data", null);
      return wife || this.husband || null;
    },
    husband() {
      const husband = this.getValueFromSource(this.memberProfile, "husband_data", null);
      if (husband) {
        return {
          ...husband.user,
          member_profile: husband,
        };
      }
      return null
    },
    memberName() {
      if (!this.memberProfile || !this.memberProfile._id) { return }
      if (this.memberProfile.full_name) { return this.memberProfile.full_name; }
      return this.memberProfile.first_name + " " + this.memberProfile.last_name;
    },
    viewRoute() {
      if (!this.memberProfile || !this.memberProfile._id) return {};
      const name = this.ministersOnly ? "ministers" : "members"
      const route = { name: `${name}-view`, params: { id: this.memberProfile._id } }
      return route
    },
  },
  watch: {
    memberProfile: {
      handler(memberProfile) {
        if (memberProfile) {
          this.avatarPath = memberProfile.avatar.path;
          this.temp_member_type_id = memberProfile.member_type_id;
          this.temp_area = memberProfile.area_id;
          this.temp_region = memberProfile.region_id;
          this.temp_district = memberProfile.district_id;
          this.temp_member_types = memberProfile.member_type;
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.fetchPageData();
    this.fetchCountries();
    this.fetchMemberTypes();
    this.fetchDepartments();
    this.fetchChurchRegions();
    this.fetchMemberStatus();
  },
  methods: {
    async fetchPageData() {
      try {
        this.loading = true;

        const { id } = this.$route.params;

        const request = await this.useJwt().mainService.memberProfiles.get(id);
        const { data } = request.data;

        this.memberProfile = { ...this.memberProfile, ...data };
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTypes() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
        };

        const request = await this.useJwt().mainService.memberTypes.list(query);
        const { data = [] } = request.data;

        this.member_types = data.map((member_type) => ({
          label: member_type.title,
          value: member_type._id,
          is_cop_minister: member_type.is_cop_minister,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberStatus() {
      try {
        this.loading = true;

        const query = {};

        const request = await this.useJwt().mainService.memberStatus.list(query);
        const { data = [] } = request.data;

        this.memberStatusOptions = data.map((member_type) => ({
          label: member_type.title,
          value: member_type._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTitlesAndDesignations(member_type_id) {
      try {
        const query = {
          member_type_id,
        };
        const member_title_resp =
          await this.useJwt().mainService.memberTitles.list(query);
        const member_designation_rep =
          await this.useJwt().mainService.memberDesignations.list(query);
        const member_titles = get(
          member_title_resp.data,
          "data.[0].categories"
        );
        const member_designations = get(
          member_designation_rep.data,
          "data.[0].categories"
        );

        this.memberTitleOptions = (member_titles || []).map((member_title) => ({
          label: member_title.title,
          value: member_title._id,
        }));

        this.memberDesignationOptions = (member_designations || []).map(
          (member_designation) => ({
            label: member_designation.designation,
            value: member_designation._id,
          })
        );

        memberTitlesAndDesignationCachedData.push({
          id: this.memberProfile.member_type_id,
          titles: this.memberTitleOptions,
          designations: this.memberDesignationOptions,
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchDepartments() {
      try {
        const response = await this.useJwt().sharedService.fetchDepartments();

        const departments = get(response, "data");

        this.departmentOptions = departments.map((department) => ({
          value: department._id,
          label: department.title,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const { region_id } = this.memberProfile;

        if (!region_id) {
          return;
        }
        const request = await this.useJwt().sharedService.fetchGeoAreas(
          { region_id }
        );
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const { area_id } = this.memberProfile;
        if (!area_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoDistricts(
          { area_id }
        );
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;

        if (!this.memberProfile.district_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoAssemblies(
          { district_id: this.memberProfile.district_id }
        );
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchCountries() {
      try {
        const response = await this.useJwt().sharedService.fetchCountries();

        const countries = get(response, "data.data");
        this.countryOptions = countries.map((country) => ({
          label: country.country,
          value: country.country,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async onCreateOrUpdateAvatar() {
      try {
        this.loading = true;
        this.errorMessage = "";

        const id = this.memberProfile._id;

        if (!this.can("member_profiles:CanUpdate")) {
          return;
        }

        const formData = new FormData();

        if (this.avatarImage) {
          formData.append("avatar", this.avatarImage);
        }

        await this.useJwt().mainService.memberProfiles.updateAvatar(
          id,
          formData
        );

        if (this.avatarImage) {
          this.avatarImage = null;
        }

        this.$emit("refetchData");
        this.$emit("update:is-add-or-update-active", false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success!",
            icon: "AlertQuestionIcon",
            variant: "success",
            text: `Avatar updated successfully`,
          },
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onImageRenderer(file) {
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          this.avatarPath = reader.result;
          this.avatarImage = file;
          this.onCreateOrUpdateAvatar();
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    resetForm() {
      this.$emit("resetUpdateData");
      this.memberProfile = {};
      this.tabIndex = 0;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-or-update {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>

<style>
.minister-profile ul.nav.nav-tabs {
  font-size: 1.1rem;
}

.minister-profile h4 {
  font-size: 1rem;
  color: #6e6b7b;
}
</style>
